"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vdom_1 = require("../../vdom");
var core_1 = require("../../../core");
var i_st_1 = require("../../../core/st/interface/i$st");
exports.defineComponent = function (targetClassOrFunction, options) {
    if (options === void 0) { options = {}; }
    var componentIdent = targetClassOrFunction.name || vdom_1.newUniqueComponentName();
    // register with element registry
    core_1.st[i_st_1.GlobalCache.COMPONENT_REGISTRY][componentIdent] = targetClassOrFunction;
    core_1.st[i_st_1.GlobalCache.COMPONENT_WEAKMAP].set(targetClassOrFunction, componentIdent);
    // assign options to be used in CustomElement derived class constructor
    targetClassOrFunction.COMPONENT_OPTIONS = options;
    // return enhanced class / function
    return targetClassOrFunction;
};
//# sourceMappingURL=define-component.js.map